export default "__VITE_ASSET__ChvEskvA__"